import axios from '../../../setup/axios/axios';
import { useAuth } from './useAuth';

const useRefreshToken = () => {
    const { UserToken, setUserToken } = useAuth();

    const refresh = async () => {
        const response = await axios.get('/api/Accounts/refresh-token',
            {
                headers: {
                    'Authorization': 'Bearer ' + UserToken.token
                }
            }
        );

        setUserToken(
            response.data.accessToken,
            response.data.refreshToken,
            response.data.expiresIn,
            response.data.loggedInUserId,
            response.data.roles,
            response.data.name,
            response.data.city,
            response.data.phoneNumber,
            response.data.email
          );

          // setUserToken(prev => {
        //     // console.log(JSON.stringify(prev));
        //     // console.log(response.data.accessToken);
        //     return {
        //         ...prev,        
                //         roles: response.data.roles,
        //         accessToken: response.data.accessToken
        //     }
        // });
        return response.data.accessToken;
    }
    return refresh;
};

export default useRefreshToken;